import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslate from "./en/translation.json";
import srTranslate from "./sr/translation.json";
import deTranslate from "./de/translation.json";
import itTranslate from "./it/translation.json";
import ruTranslate from "./ru/translation.json";

const availableLanguages = ["en", "sr", "de", "it", "ru"];

const resources = {
  en: { translation: enTranslate },
  sr: { translation: srTranslate },
  de: { translation: deTranslate },
  it: { translation: itTranslate },
  ru: { translation: ruTranslate },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",

    detection: {
      // Always use language selected in the app (stored in localStorage)
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },

    debug: true,
    supportedLngs: availableLanguages,
    resources,
  });

export default i18n;